import { api } from "@/lib/api";
import { TenantInfo, CompanyStatus } from "@/types/company";

export const tenantService = {
  getCurrentTenant: async () => {
    const response = await api.get<TenantInfo>("/api/v1/tenants/current");
    return response.data;
  },
  getCompanyStatus: async () => {
    const response = await api.get<CompanyStatus>("/api/v1/company/status");
    return response.data;
  },
};
